export interface UiCardSessionViewModel {
  name: string;
  startTime: string;
  endTime: string;
  recurrenceType: string;
  scheduledDate?: Date | string;
  timezone?: string;
  rrule?: string;
  recurrence?: {
    type: string;
    every?: number;
    monthlyDay?: number;
    monthlyWeek?: number;
    monthlyWeekDay?: string;
    weeklyDays?: string[];
  };
}

export interface UiCardViewModel {
  id: string;
  courseTitle: string;
  subject: string;
  imageBannerSource: string;
  description: string;
  isEnrolled?: boolean;
  totalMeetings?: number;
  price?: number;
  medium?: string;
  startDate?: Date | string | null;
  duration?: string;
  level?: string;
  sessions?: UiCardSessionViewModel[];
  showButtons?: boolean;
  submitButtonText?: string;
  maxSessionsDisplayed?: number;
}